// 转化颜色：值为：rgba(194, 78, 78, 1) 转化为： { r: 194, g: 78, b: 78, a: 1 }
import hexToRgba from 'hex-to-rgba'

export function exchangeRgbaToObject(color) {
  const values = color
    .replace(/rgba?\(/, '')
    .replace(/\)/, '')
    .replace(/[\s+]/g, '')
    .split(',')
  const a = parseFloat(values[3] || 1)
  const r = values[0]
  const g = values[1]
  const b = values[2]
  return {
    r,
    g,
    b,
    a,
  }
}

// 转化颜色：值为：{ r: 194, g: 78, b: 78, a: 1 } 转化为: rgba(194, 78, 78, 1)
export function exchangeRgbaObjectToRgba(color) {
  return `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a || 1})`
}

export function exchangeRgbObjectToRgb(color) {
  return `rgb(${color.r}, ${color.g}, ${color.b})`
}

export function exchangeLinearGradientToObject(color) {
  const arr = /^linear-gradient\((.+)\)$/.exec(color)
  if (arr && arr[1]) {
    const arr2 = arr[1].split(',').map((item) => item.trim())
    const angle = parseInt(arr2[0], 10)
    arr2.shift()
    const linear = arr2.map((item) => item.split(' '))
    if (linear.some((item) => item.length !== 2)) {
      console.error('linear gradient 没有渐变点')
    } else {
      return {
        angle,
        // 将百分比转换为 0 - 1
        stops: linear.map((item) => {
          return [item[0], parseInt(item[1], 10) / 100]
        }),
      }
    }
  }
}

/**
 * rgbToHex
 * @param {string} color
 */
export function rgbToHex(color) {
  if (color && color !== 'transparent' && color !== 'rgb(NaN, NaN, NaN)') {
    const rgb = color.split(',')
    const r = parseInt(rgb[0].split('(')[1], 10)
    const g = parseInt(rgb[1], 10)
    const b = parseInt(rgb[2].split(')')[0], 10)
    // eslint-disable-next-line no-bitwise
    const hex =
      '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)
    return hex
  }
  return ''
}

/**
 * isHexColor， # 后有且仅有 6 位字符才认为是正确的，其他情况都认为是非法的，如 #fff
 * @param {string} value
 */
export function isHexColor(value) {
  return /^#[\d\w]{6}$/i.test(value)
}

export const rgbaRe =
  /^rgba?\(((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?)))?\)$/
export const rgbRe = /^rgb\(((\d+),\s*(\d+),\s*(\d+))\)$/

/**
 * isRGB，只支持 rgb
 * @param {number[]|string} value
 */
export function isRGB(value) {
  if (typeof value === 'string' && rgbRe.test(value)) {
    return true
  }

  if (Array.isArray(value) && value.length === 3) {
    return value.every((item) => {
      if (typeof item !== 'number') return false
      // red green blue 通道
      return item >= 0 && item <= 255
    })
  }

  return false
}

/**
 * isRGBA，支持 rgba 与 rgb
 * @param {number[]|string} value
 */
export function isRGBA(value) {
  if (typeof value === 'string' && rgbaRe.test(value)) {
    return true
  }

  if (Array.isArray(value) && (value.length === 3 || value.length === 4)) {
    return value.every((item, index) => {
      if (typeof item !== 'number') return false
      // alpha 通道
      if (index === 3) return item >= 0 && item <= 1
      // red green blue 通道
      return item >= 0 && item <= 255
    })
  }

  return false
}

export function hexToRgbaArr(val) {
  if (typeof val !== 'string' || !isHexColor(val)) return
  const rgba = hexToRgba(val)
  if (!rgba) return
  return rgba
    .replace(/^rgba\((.+)\)$/, '$1')
    .replace(' ', '')
    .split(',')
    .map((item) => Number(item))
}

/**
 * #000000 转为 {r: 0, g: 0, b: 0 }
 * @param {string} hex
 * @returns
 */
export function hex2rgb(hex) {
  hex = hex.slice(1)
  const change = (val) => parseInt(val, 16) || 0 // 避免NaN的情况
  return {
    r: change(hex.slice(0, 2)),
    g: change(hex.slice(2, 4)),
    b: change(hex.slice(4, 6)),
  }
}
